import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Text from '#components/a/Text'
import Headline from '#components/a/Headline'
import AusbildungsplanHeaderModal from './AusbildungsplanHeaderModal'

function AblehnenButton(props) {
  const {ablehnen, disabled} = props
  return (
    <AusbildungsplanHeaderModal
      id="kapitel_ablehnen_button"
      trigger={i18n.t('kapitel_ablehnen_button')}
      variant="secondary"
      modifiers={['ablehnen']}
      confirmCallback={ablehnen}
      confirmText={i18n.t('kapitel_ablehnen_button')}
      disabled={disabled}
    >
      <Headline modifier="article" importance={2} text={i18n.t('kapitel_ablehnen_modal_header')} />
      <Text modifier="small" text={i18n.t('kapitel_ablehnen_modal_text')} />
    </AusbildungsplanHeaderModal>
  )
}

AblehnenButton.propTypes = {
  ablehnen: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default AblehnenButton
